import Button from 'Components/Button';
import Label from 'Components/Label';
import ModalComponent from 'Components/Modal';
import ProgressBar from 'Components/ProgressBar';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CreditoService from 'Services/Http/Credito.service';
import OrdenPagoService from 'Services/Http/OrdePago.service';
import { formatCurrency } from 'Utils/Functions';
const AsignarOrdenPagoComponente = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [odps, setOdps] = useState([]);
  const { odp } = useSelector((state) => state.odp);

  const [stateModal, setStateModal] = useState(false);
  const [messageModal, setMessageModal] = useState('');
  const [typeModal, setTypeModal] = useState('');

  useEffect(() => {
    if (Object.keys(odp).length > 0) {
      setLoader(true);
      getlastOdps();
    } else {
      navigate(-1), { replace: true };
    }
  }, [odp]);

  const getlastOdps = async (page) => {
    setLoader(true);
    try {
      const response = await CreditoService.autorizados({ page });
      createRows(response.data);
    } catch (e) {
      console.log(e);
    }
  };

  const asiganarODP = async (idCredito) => {
    try {
      await OrdenPagoService.asignar({ idCredito, idOdp: odp.id });
      setMessageModal('Guardado Exitoso');
      setTypeModal('success');
      setStateModal(true);
      getlastOdps(1);
      navigate(-1), { replace: true };
    } catch (error) {
      console.log(error);
      setLoader(false);
      setStateModal(true);
      setTypeModal('error');
      setMessageModal('Ocurrio un error, revise e intente de nuevo');
    }
  };

  const changeState = (state) => {
    setStateModal(state);
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.nombreCompleto}</td>
        <td className="px-6 py-4">{item.folioCredito}</td>
        <td className="px-6 py-4">
          {item.autorizacion ? moment(item.autorizacion).format('DD/MM/YYYY') : ''}
        </td>
        <td className="px-6 py-4">{formatCurrency(item.montoSolicitado)}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoAprovado)}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoDispercion)}</td>
        <td className="px-6 py-4">{item.asignado}</td>
        <td>
          <Button label="Asignar" onClick={() => asiganarODP(item.folioCredito)} />
        </td>
      </tr>
    ));
    setOdps(data);
    setLoader(false);
  };

  return (
    <>
      <Label text={'Lista ordenes de pago'} />
      <div className="flex flex-row gap-4">
        <div>Nombre: </div>
        <div>{odp?.nombreCliente || 'Cargando...'}</div>
      </div>
      <div className="flex flex-row gap-4">
        <div>Monto: </div>
        <div>{formatCurrency(odp?.monto) || 'Cargando...'}</div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Autorizado
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Solicitado
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Aprovado
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Dispercion
              </th>
              <th scope="col" className="px-6 py-3">
                Agente Asignado
              </th>
              <th scope="col" className="px-6 py-3">
                Asignar
              </th>
            </tr>
          </thead>
          <tbody>{odps}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
      <ModalComponent
        show={stateModal}
        changeState={changeState}
        typeModal="notificacion"
        title={messageModal}
        stateModal={typeModal}
        actionOK={() => navigate(-1)}
      />
    </>
  );
};
export default AsignarOrdenPagoComponente;
